/**
 * Components registered globally, for the site (main.ts) and for Storybook
 * (.storybook/preview.js). One list, so anything the site can render without
 * importing, Storybook can render too.
 */
import { defineAsyncComponent } from 'vue';
import AnimatedComponent from '@/components/AnimatedComponent.vue';
import BlogFeed from '@/components/blog/BlogFeed.vue';
import CardRow2 from '@/components/CardRow2.vue';
import ArticleCard from '@/components/card/ArticleCard/ArticleCard.vue';
import TextGrid from '@/components/card/TextGrid.vue';
import TextGrid2 from '@/components/card/TextGrid2.vue';
import TextGrid3 from '@/components/card/TextGrid3.vue';
import FilterBar from '@/components/FilterBar.vue';
import GridParent from '@/components/grid/GridParent.vue';
import GridContainer from '@/components/grid/GridContainer.vue';
import GridWrapper from '@/components/grid/GridWrapper.vue';
import HeroBanner from '@/components/HeroBanner/HeroBanner.vue';
import ImageCard from '@/components/card/ImageCard/ImageCard.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';
import ImageCard2 from '@/components/card/ImageCard2.vue';
import MyButton from '@/components/Button/Button.vue';
import ButtonRow from '@/components/ButtonRow.vue';
import SidebarNav from '@/components/SidebarNav.vue';
import SideNav from '@/components/SideNav.vue';
import MyLogo from '@/components/MyLogo.vue';
import Icon from '@/components/Icon.vue';
import PageWrapper from '@/components/grid/PageWrapper.vue';
import TextStats from '@/components/card/TextStats.vue';
import TextBlock from '@/components/text/TextBlock/TextBlock.vue';
import TextHeader from '@/components/text/TextHeader.vue';
import TextImage from '@/components/card/TextImage.vue';
import TextLink from '@/components/text/TextLink.vue';

// Heavy or rarely-rendered components are loaded on demand: each becomes its own
// webpack chunk that only downloads when the component first renders, keeping it
// out of the initial entry bundle. None of these sit in the always-mounted app
// shell or above the fold, so splitting them costs no first-paint work — the
// subscribe components render at the very bottom of the home page.
const HeroAnimated = defineAsyncComponent(() => import('@/components/HeroAnimated.vue'));
const HeroAnimated2 = defineAsyncComponent(() => import('@/components/HeroAnimated2.vue'));
const TestimonialCarousel = defineAsyncComponent(
  () => import('@/components/TestimonialCarousel.vue')
);
const MarkdownRenderer = defineAsyncComponent(
  () => import('@/components/text/MarkdownRenderer.vue')
);
const ProjectPreview = defineAsyncComponent(() => import('@/components/ProjectPreview.vue'));
const DynamicText = defineAsyncComponent(() => import('@/components/text/DynamicText.vue'));
const ThumbDetail = defineAsyncComponent(() => import('@/components/ThumbDetail/ThumbDetail.vue'));
const MyInput = defineAsyncComponent(() => import('@/components/form/MyInput.vue'));
const FormCentered = defineAsyncComponent(() => import('@/components/card/FormCentered.vue'));
const MyForm = defineAsyncComponent(() => import('@/components/card/MyForm.vue'));
const NewsletterSubscription = defineAsyncComponent(
  () => import('@/components/form/NewsletterSubscription.vue')
);
const NewsletterBanner = defineAsyncComponent(
  () => import('@/components/blog/NewsletterBanner.vue')
);


export function registerGlobalComponents(app) {
    app
    .component('AnimatedComponent', AnimatedComponent)
    .component('TestimonialCarousel', TestimonialCarousel)
    .component('BlogFeed', BlogFeed)
    .component('CardRow2', CardRow2)
    .component('ArticleCard', ArticleCard)
    .component('TextGrid', TextGrid)
    .component('TextGrid2', TextGrid2)
    .component('TextGrid3', TextGrid3)
    .component('FilterBar', FilterBar)
    .component('GridContainer', GridContainer)
    .component('GridParent', GridParent)
    .component('GridWrapper', GridWrapper)
    .component('HeroBanner', HeroBanner)
    .component('ImageCard', ImageCard)
    .component('ImageCard2', ImageCard2)
    .component('BreadCrumb', BreadCrumb)
    .component('MyButton', MyButton)
    .component('ButtonRow', ButtonRow)
    .component('MyLogo', MyLogo)
    .component('Icon', Icon)
    .component('PageWrapper', PageWrapper)
    .component('ProjectPreview', ProjectPreview)
    .component('TextStats', TextStats)
    .component('TextBlock', TextBlock)
    .component('TextHeader', TextHeader)
    .component('TextImage', TextImage)
    .component('TextLink', TextLink)
    .component('ThumbDetail', ThumbDetail)
    .component('MarkdownRenderer', MarkdownRenderer)
    .component('DynamicText', DynamicText)
    .component('HeroAnimated', HeroAnimated)
    .component('HeroAnimated2', HeroAnimated2)
    .component('MyInput', MyInput)
    .component('NewsletterSubscription', NewsletterSubscription)
    .component('NewsletterBanner', NewsletterBanner)
    .component('FormCentered', FormCentered)
    .component('MyForm', MyForm)
    .component('SidebarNav', SidebarNav)
    .component('SideNav', SideNav);
  return app;
}
